module.exports = __webpack_public_path__ + "img/仙人掌-2.62f56045.jpg";